import * as Types from '../../../../_types/serverTypes';

import { useMutation, UseMutationOptions } from 'react-query';
import { fetcher } from 'src/clients/graphql/idr';
export type UpdateProfileMutationVariables = Types.Exact<{
  data?: Types.InputMaybe<Types.InputMutationData_ProfileDto>;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutations', userMutations?: { __typename?: 'UserMutations', updateProfile?: { __typename?: 'Response_ProfileDto', isSuccess?: boolean | null | undefined } | null | undefined } | null | undefined };


export const UpdateProfileDocument = `
    mutation updateProfile($data: InputMutationData_ProfileDto) {
  userMutations {
    updateProfile(request: $data) {
      isSuccess
    }
  }
}
    `;
export const useUpdateProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProfileMutation, TError, UpdateProfileMutationVariables, TContext>) =>
    useMutation<UpdateProfileMutation, TError, UpdateProfileMutationVariables, TContext>(
      'updateProfile',
      (variables?: UpdateProfileMutationVariables) => fetcher<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, variables)(),
      options
    );